var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7886 2.17343L1.97021 17.9919V46.989H30.9673L46.7857 31.1705M14.8289 11.4925V14.4922M16.3288 12.9924H13.3291M7.18969 19.0317V22.0315M8.68954 20.5316H5.68984M7.18969 31.4305V34.4302M8.68954 32.9304H5.68984M37.4667 34.1302H34.467M35.9668 32.6304V35.6301M29.9274 41.7695H26.9277M28.4276 40.2696V43.2693M17.5287 41.7695H14.529M16.0288 40.2696V43.2693M14.9689 33.9903C16.9969 36.0325 19.5289 37.502 22.3082 38.2498C23.0196 38.461 23.7895 38.2608 24.308 37.7299L35.9668 25.9911L40.9663 31.0506C41.9981 32.1212 43.5248 32.5564 44.9659 32.1904C46.6796 31.6906 47.8546 30.1158 47.8456 28.3308V4.99315C47.8456 2.78423 46.055 0.99355 43.846 0.99355H20.6284C18.8434 0.984631 17.2685 2.15963 16.7687 3.87326C16.4028 5.31443 16.8379 6.84113 17.9086 7.87286L22.9681 12.9924L11.2293 24.7312C10.6983 25.2497 10.4982 26.0195 10.7093 26.731C11.47 29.4816 12.9387 31.9846 14.9689 33.9903ZM23.3281 5.43311C23.1108 5.43458 22.9156 5.56611 22.8327 5.76691C22.7497 5.96771 22.7952 6.19866 22.9481 6.35302L28.9475 12.4524L16.2488 25.2311C15.6986 25.7844 15.5474 26.62 15.8688 27.3309C16.4323 28.607 17.2101 29.7771 18.1686 30.7906C19.1821 31.749 20.3522 32.5269 21.6283 33.0903C22.3392 33.4117 23.1748 33.2605 23.728 32.7104L36.5068 19.9917L42.6062 25.9911C42.7605 26.1439 42.9915 26.1894 43.1923 26.1065C43.3931 26.0235 43.5246 25.8283 43.5261 25.6111V5.43311H23.3281Z",
    stroke: "#88AB8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprove);
export default __webpack_public_path__ + "static/media/improve.05dd9eab3fe8c3a7404f54d8b9037dd4.svg";
export { ForwardRef as ReactComponent };